import React, { Component } from "react"
import MetaTags from 'react-meta-tags'
import { Col, Alert, Container, Row } from "reactstrap"

// import images
import logodark from "assets/images/kattam-login.png"
import CarouselPage from "pages/Common/CarouselPage"

import { connect } from "react-redux"
import PropTypes from 'prop-types'

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

// actions
import { apiError, loginUser, onGetCaptcha } from "store/actions"
import { withRouter } from "react-router-dom"
import { isEmpty, isEqual } from "lodash"

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            captchaOject: {}
        }

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    // handleValidSubmit
    handleValidSubmit(event, values) {
        values.userType = "GROUP"
        values.captchaToken = this.state.captchaOject.captchaToken
        console.log('inside handleValidSubmit of login component in group', values)
        this.props.loginUser(values, this.props.history)
    }

    componentDidMount() {
        this.props.apiError("")
        this.props.onGetCaptcha()
    }

    componentDidUpdate(prevProps, prevState) {
        console.log("componentDidUpdate->called")
        const { captchaOject, actionResult } = this.props
        if (!isEmpty(captchaOject) && !isEqual(prevProps.captchaOject, captchaOject)) {
            this.setState({ captchaOject })
            console.log("componentDidUpdate->captchaOject, ", captchaOject)
        }
    }

    renderError() {
        if (!isEmpty(this.props.error)) {
            if (isEqual(this.props.error, "Bad credentials")) {
                return <Alert color="danger">Invalid username or password</Alert>
            } else if (isEqual(this.props.error, "Invalid Captcha")) {
                return <Alert color="danger">Invalid captcha</Alert>
            } else {
                return <Alert color="danger">{this.props.error}</Alert>
            }
        } else
            return null;
    }

    render() {
        const { captchaOject } = this.state
        const imageSrc = "data:image/png;base64," + captchaOject.captchaImage;
        return (
            <React.Fragment>
                <div>
                    <MetaTags>
                        <title>Login | Kattam</title>
                    </MetaTags>
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <CarouselPage />

                            <Col xl={5}>
                                <div className="auth-full-page-content p-md-5 p-4">
                                    <div className="w-100">
                                        <div className="d-flex flex-column h-100">
                                            <div className="mb-4 mb-md-5">
                                                <img
                                                    src={logodark}
                                                    alt=""
                                                    height="80"
                                                    className="auth-logo-dark"
                                                />

                                            </div>
                                            <div className="my-auto">
                                                <div>
                                                    <h5 className="text-primary">Enterprise Login</h5>
                                                </div>

                                                <div className="mt-4">
                                                    <AvForm
                                                        className="form-horizontal"
                                                        onValidSubmit={this.handleValidSubmit}
                                                    >
                                                        {/* {this.props.error && this.props.error ? (
                                                            <Alert color="danger">Invalid credentials</Alert>
                                                        ) : null} */}

                                                        {this.renderError()}

                                                        <div className="mb-3">
                                                            <AvField
                                                                name="groupCode"
                                                                label="Enterprise Code"
                                                                className="form-control"
                                                                placeholder="Enter enterprise code"
                                                                type="text"
                                                                required
                                                                errorMessage="Please enter Enterprise code"
                                                                value=""
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <AvField
                                                                name="username"
                                                                label="Username"
                                                                className="form-control"
                                                                placeholder="Enter username"
                                                                type="text"
                                                                required
                                                                errorMessage="Please enter your username"
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <AvField
                                                                name="password"
                                                                label="Password"
                                                                type="password"
                                                                required
                                                                placeholder="Enter password"
                                                                errorMessage="Please enter your password"
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <AvField
                                                                name="userCaptcha"
                                                                label="Captcha"
                                                                type="text"
                                                                required
                                                                placeholder="Enter Captcha"
                                                                errorMessage="Please enter your Captcha"
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <img id="ItemPreview" src={imageSrc} />
                                                        </div>

                                                        <div className="mt-3 d-grid">
                                                            <button
                                                                className="btn btn-primary btn-block waves-effect waves-light"
                                                                type="submit"
                                                            >
                                                                Log In
                                                            </button>
                                                        </div>
                                                    </AvForm>

                                                </div>
                                            </div>
                                            <div className="mt-4 mt-md-5 text-center">
                                                <p className="mb-0">
                        Copyright © {new Date().getFullYear()} Kattam Intelligence Pte. Ltd. All rights reserved.{" "}
                        </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

Login.propTypes = {
    apiError: PropTypes.any,
    error: PropTypes.any,
    onGetCaptcha: PropTypes.func,
    history: PropTypes.object,
    loginUser: PropTypes.func,
}

const mapStateToProps = state => {
    const { error, captchaOject } = state.Login
    return { error, captchaOject }
}

export default withRouter(
    connect(mapStateToProps, { loginUser, apiError, onGetCaptcha })(Login)
)